import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api/client';
import { AuthContext } from '../context/AuthContext';

// Guards a page by the caller's role. The API enforces the same rule; this only hides the page.
const RoleRoute = ({ roles, children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const [role, setRole] = useState(undefined);

  useEffect(() => {
    if (!isAuthenticated) return;
    api.get('/api/users/me/').then((r) => setRole(r.data.role)).catch(() => setRole(null));
  }, [isAuthenticated]);

  if (!isAuthenticated) return <Navigate to="/login" />;
  if (role === undefined) return <p style={{ padding: '4rem', textAlign: 'center' }}>Loading…</p>;
  return roles.includes(role) ? children : <Navigate to="/dashboard" />;
};

export default RoleRoute;
